import request from '@/utils/request'

// 验证码登录
// export function loginBySms(data) {
//   return request({
//     url: '/a/tob/user/loginBySms',
//     method: 'post',
//     data
//   })
// }

export function getListData() {
  return request({
    url: '/a/tob/device/listData',
    method: 'get'
  })
}

